import type { IUserNotificationSchema } from '~/@api/generated-api-types-user/Api'

export function getColorByCategory(
  category: IUserNotificationSchema['category']
) {
  if (category === 'fee_notice') return '#FFDD99'
  if (category === 'success') return '#DAFFC7'
  if (category === 'warning') return '#FFDD99'
  return '#FFC7D0'
}
